
import http from '../utils/http'
// export function getStoreDetail(query) {
//     return http({
//       url: 'user/h5/getStoreDetail',
//       method: 'get',
//       params: query
//     })
// }

export function bindStore(data) {
    return http({
      url: '/api/user/login',
      method: 'post',
      data: data
    })
}

export function getStoreDetail(data) {
    return http({
      url: '/api/web/store/getStoreDetail',
      method: 'post',
      data: data
    })
}

//获取download url
export function getDownloadurl(data) {
  return http({
    url: '/api/user/version/getDownloadUrl?sysType=' + data.sysType,
    method: 'post',
    data: data
  })
}

export function getDownloadAndroid(data) {
  return http({
    url: '/api/web/download/android?sysType=' + data.sysType + '&storeId=' + data.storeId,
    method: 'get'
  })
}

export function getDownloadIos(data) {
  return http({
    url: '/api/web/download/ios?sysType=' + data.sysType + '&storeId=' + data.storeId,
    method: 'get'
  })
}